export const list = [{
    title: 'Default',
    id: 'default',
    path: './default/theme.js'
    // }, {
    //     title: 'Another',
    //     id: 'another',
    //     path: './another/theme.js'
}, {
    title: 'People',
    id: 'people',
    path: './people/theme.js'
}, {
    title: 'Centered',
    id: 'centered',
    path: './centered/theme.js'
}]